import React, { useEffect, useCallback } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import useStyles from './PaymentResult.styles';
import tPaths from '../../utils/tPaths';
import RedbullLogoIcon from '../../assets/images/redbullIcon/RedBullLogoIcon';

const PaymentResult = () => {
  const styles = useStyles();

  const { t } = useTranslation();

  const openAppButtonHandler = useCallback(() => {
    window.location.replace(`https://wndr.azurewebsites.net/payment?status=redirectToApp`);
  }, []);

  const changeDocumentTitle = useCallback((title: string) => {
    document.title = title;
  }, []);

  useEffect(() => {
    changeDocumentTitle('WNDR payment redirect');

    return () => changeDocumentTitle('WNDR admin panel');
  }, []);

  return (
    <Box className={styles.background}>
      <Box className={styles.emailVerificationForm}>
        <Box className={styles.inputContainer}>
          <Box alignSelf="center" margin={1} py={1}>
            <RedbullLogoIcon />
          </Box>
          <Typography variant="h5" className={styles.subtitle}>
            {t(tPaths.payment.message)}
          </Typography>
          <Box pt={4} display="flex" justifyContent="center">
            <Button onClick={openAppButtonHandler} color="primary">
              {t(tPaths.payment.backButton)}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentResult;
